import React from 'react'
import { Field } from 'formik'
import { useUsersQuery } from '../../../queries/users'
import useStore from '../../../store'
import { Organization } from '../../../api/organizations'
import { User } from '../../../api/users'
import { buildListAsInputOptions } from '../../../utils/forms'
import { getUserLabel } from '../../../utils/users'
import { UserInputLabel } from '../../missions/mission-form'
import AutocompleteField from '../../form/fields/autocomplete'
import WorkerLabel from '../../texts/worker-label'
import FieldColumn from '../field-column'
import MultiSelectField from '../../form/fields/multi-select'

/**
 * Internal workers filter field component
 * Filters workers that are associated with the current organization
 * Uses the same query logic as the payroll generation form
 */
const InternalWorkersFilterField: React.FC = () => {
  const currentOrganization = useStore(state => state.session.currentOrganization) as Organization

  // Query internal workers for the current organization
  const usersQuery = useUsersQuery({
    'roles.kind': 'worker',
    filter: JSON.stringify({
      associations: {
        $elemMatch: {
          organization: currentOrganization._id,
          status: ['accepted', 'pending'],
        },
      },
    }),
  })

  const items = React.useMemo(() => {
    return buildListAsInputOptions(usersQuery?.data || [], {
      labelBuilder: (user: User) => getUserLabel(user),
      renderLabel: user => UserInputLabel({ user, organization: currentOrganization }),
    })
  }, [usersQuery?.data])

  return (
    <FieldColumn>
      <Field
        label={<WorkerLabel label="Salarié(s)" />}
        name="user"
        component={MultiSelectField}
        options={items}
        selectDefaultChooseOptionLabel={
          <>
            Choisir le <WorkerLabel />
          </>
        }
        isLoading={usersQuery.isLoading}
      />
    </FieldColumn>
  )
}

export default InternalWorkersFilterField
